import { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useForgotPassword } from '../../store/query/userQuery';

export const useForgotPasswordForm = () => {
  const [alert, setAlert] = useState({
    open: false,
    severity: 'success',
    message: '',
  });

  const { mutate: forgotPasswordMutate, isLoading } = useForgotPassword();

  const handleClose = () => {
    setAlert((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const showToast = (msg, sev = 'success') => {
    setAlert({
      open: true,
      severity: sev,
      message: msg,
    });
  };

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Invalid email address')
        .required('Email is required'),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        await forgotPasswordMutate(values.email, {
          onSuccess: () => {
            showToast('Reset email sent successfully', 'success');
            resetForm();
          },
          onError: (error) => {
            showToast(
              error?.response?.data?.message || 'Failed to send reset email',
              'error'
            );
          },
        });
      } catch (error) {
        showToast(
          error?.response?.data?.message || 'Failed to send reset email',
          'error'
        );
      }
    },
  });

  return {
    alert,
    isLoading,
    formik,
    handleClose,
    showToast,
  };
};
